import Component from './AmountInput'

export default Component
